import { auth, firebaseFunctions, firestore } from '../../firebase';
import { transformFirebaseResponse, UnableToFetchData } from '../utils';
import { COLLECTIONS } from '../constants';

/**
 * Fetch user details by authId
 * @returns {Promise<{[p: string]: any, id: string}>}
 * @param authId
 */
const fetchUserByAuthId = async (authId) => {
  try {
    const userData = await firestore
      .collection(COLLECTIONS.USERS)
      .where('authId', '==', authId)
      .get();

    const user = transformFirebaseResponse(userData);
    return user[0];
  } catch (e) {
    // UnableToFetchData();
  }
};

/**
 * Fetch user details by userId
 * @returns {Promise<{[p: string]: any, id: string}>}
 * @param userId
 */

/**
 * Fetch team details by teamId
 * @returns {Promise<{[p: string]: any, id: string}>}
 * @param teamId
 */
const fetchTeamById = async (teamId) => {
  try {
    if (!!teamId) {
      const teamData = await firestore
        .collection(COLLECTIONS.TEAMS)
        .doc(teamId)
        .get();
      if (!teamData.empty) {
        return { ...teamData.data(), id: teamData.id };
      }
    }
  } catch (e) {
    // UnableToFetchData();
  }
};

/**
 * Register and Create user in bulk -> calls cloud function.
 * @param usersData
 * @param createdBy
 * @param eventId
 * @param enterpriseId
 * @returns {Promise<HttpsCallableResult>}
 */
const registerAndCreateUsers = async ({
  usersData = [],
  createdBy,
  eventId,
  enterpriseId,
}) => {
  try {
    const callable = firebaseFunctions.httpsCallable('registerAndCreateUsers');
    return await callable({ usersData, createdBy, eventId, enterpriseId });
  } catch (e) {
    console.log(e);
  }
};

/**
 * Login
 * @param email
 * @param password
 * @returns {Promise<{verifyBeforeUpdateEmail(newEmail: string, actionCodeSettings?: (firebase.auth.ActionCodeSettings | null)): Promise<void>, metadata: firebase.auth.UserMetadata, updateProfile(profile: {displayName?: string | null, photoURL?: string | null}): Promise<void>, providerData: (firebase.UserInfo | null)[], displayName: string | null, delete(): Promise<void>, getIdTokenResult(forceRefresh?: boolean): Promise<firebase.auth.IdTokenResult>, photoURL: string | null, uid: string, toJSON(): Object, reload(): Promise<void>, reauthenticateWithRedirect(provider: firebase.auth.AuthProvider): Promise<void>, providerId: string, multiFactor: firebase.User.MultiFactorUser, linkWithPhoneNumber(phoneNumber: string, applicationVerifier: firebase.auth.ApplicationVerifier): Promise<firebase.auth.ConfirmationResult>, getIdToken(forceRefresh?: boolean): Promise<string>, email: string | null, linkWithCredential(credential: firebase.auth.AuthCredential): Promise<firebase.auth.UserCredential>, reauthenticateAndRetrieveDataWithCredential(credential: firebase.auth.AuthCredential): Promise<firebase.auth.UserCredential>, updatePassword(newPassword: string): Promise<void>, reauthenticateWithPhoneNumber(phoneNumber: string, applicationVerifier: firebase.auth.ApplicationVerifier): Promise<firebase.auth.ConfirmationResult>, linkWithRedirect(provider: firebase.auth.AuthProvider): Promise<void>, userRes: {[p: string]: any, id: string}, emailVerified: boolean, linkAndRetrieveDataWithCredential(credential: firebase.auth.AuthCredential): Promise<firebase.auth.UserCredential>, isAnonymous: boolean, linkWithPopup(provider: firebase.auth.AuthProvider): Promise<firebase.auth.UserCredential>, reauthenticateWithPopup(provider: firebase.auth.AuthProvider): Promise<firebase.auth.UserCredential>, phoneNumber: string | null, reauthenticateWithCredential(credential: firebase.auth.AuthCredential): Promise<firebase.auth.UserCredential>, updateEmail(newEmail: string): Promise<void>, unlink(providerId: string): Promise<firebase.User>, sendEmailVerification(actionCodeSettings?: (firebase.auth.ActionCodeSettings | null)): Promise<void>, tenantId: string | null, updatePhoneNumber(phoneCredential: firebase.auth.AuthCredential): Promise<void>, refreshToken: string}>}
 */

/**
 * Log out.
 * @returns {Promise<boolean|*>}
 */
const signOut = async () => {
  try {
    await auth.signOut();
    return true;
  } catch (e) { }
};

export { fetchUserByAuthId, fetchTeamById, registerAndCreateUsers, signOut };
